import { LayoutOverlayContext } from '../context'
import {
  useInitData,
  useMinimizedModalsContext,
  useUk,
  useUserData,
} from '../hooks'
import { isDevelopmentEnvironment } from '../utils/common'
import { isStaffUser } from '../utils/user'

function LayoutOverlayContextProvider({ children }) {
  const user = useUserData()
  const { config } = useUk()
  const { permissions } = useInitData()

  const { entriesValues } = useMinimizedModalsContext()

  const value = {
    showGretaAIChat:
      isDevelopmentEnvironment() ||
      (permissions?.can_use_greta_chat && config.allow_greta),
    showProductFruits: isStaffUser(user) && config.enable_product_fruits,
    withModalsTray: entriesValues.length > 0,
  }

  return <LayoutOverlayContext value={value}>{children}</LayoutOverlayContext>
}

export default LayoutOverlayContextProvider
